<template>
  <div class="app-container">
    <div class="app-content">
      <el-card class="series-history" shadow="never">
        <template slot="header">
          <el-form inline size="small">
            <el-form-item :label="$t('text.lb')">
              <el-button-group>
                <el-button :type="dateType === 'day' ? 'primary' : ''" @click="dateType = 'day'">{{ $t('text.r') }}</el-button>
                <el-button :type="dateType === 'month' ? 'primary' : ''" @click="dateType = 'month'">{{ $t('text.y') }}</el-button>
                <el-button :type="dateType === 'year' ? 'primary' : ''" @click="dateType = 'year'">{{ $t('text.n') }}</el-button>
                <el-button :type="dateType === 'total' ? 'primary' : ''" @click="dateType = 'total'">{{ $t('text.z') }}</el-button>
              </el-button-group>
            </el-form-item>
            <el-form-item v-show="dateType !== 'total'" :label="$t('text.shijian')">
              <el-date-picker
                v-show="dateType === 'day'"
                v-model="queryParams.time"
                type="date"
                style="width: 160px !important; margin-top: 0;"
              />
              <el-date-picker
                v-show="dateType === 'month'"
                v-model="queryParams.time"
                type="month"
                style="width: 160px !important; margin-top: 0;"
              />
              <el-date-picker
                v-show="dateType === 'year'"
                v-model="queryParams.time"
                type="year"
                style="width: 160px !important; margin-top: 0;"
              />
            </el-form-item>
            <el-form-item v-show="dateType === 'day'" :label="$t('text.sb')">
              <el-select v-model="id" @change="changeVal">
                <el-option-group v-for="item in deviceOptions" :key="item.id" :label="item.sn">
                  <el-option
                    v-for="device in item.children"
                    :key="device.id"
                    :label="device.sn"
                    :value="device.id"
                  />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item v-show="dateType === 'day'" :label="$t('text.cs')">
              <el-select
                v-model="queryParams.fields"
                multiple
                style="width: 600px !important"
              >
                <el-option
                  v-for="item in paramOptions"
                  :key="item.value"
                  :label="item.translation ? $t(item.label) : item.label"
                  :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" type="primary" @click="handleQuery">{{ $t('button.cx') }}</el-button>
            </el-form-item>
          </el-form>
        </template>
        <template slot="default">
          <toggle-chart
            :data="chart.data"
            :columns="chart.columns"
            :setting="chart.setting"
            :extend="chart.extend"
            :format="chart.format"
            :unit="chart.unit"
          />
        </template>
      </el-card>
    </div>
  </div>
</template>

<script>
import ToggleChart from '@views/Charts/ToggleChart3.vue'
import { GetInvertersForHistory } from '@apis/Stations.js'
import { GetClusterInvHistoryData, GetClusterMYReportData } from '@apis/Statistics.js'
import { getMonthLength, combineData } from '@utils'
export default {
  components: {
    ToggleChart
  },
  data () {
    return {
      dateType: 'day',
      queryParams: { time: new Date() },
      id: '',
      inverterList: [],
      deviceOptions: [],
      fullLoading: null,
      disabled: false,
      paramOptions: [
        { label: 'text.zdl', value: 'etotal', unit: 'kWh', translation: true },
        { label: 'text.wdu', value: 'temperature', unit: '℃', translation: true },
        { label: 'text.dwpl', value: 'fac', unit: 'Hz', translation: true },
        { label: 'text.zglv', value: 'pac', unit: 'kW', translation: true },
        { label: 'text.jlscdyr', value: 'vac1', unit: 'V', translation: true },
        { label: 'text.jlscdlr', value: 'iac1', unit: 'A', translation: true },
        { label: 'text.jlscdys', value: 'vac2', unit: 'V', translation: true },
        { label: 'text.jlscdls', value: 'iac2', unit: 'A', translation: true },
        { label: 'text.jlscdyt', value: 'vac3', unit: 'V', translation: true },
        { label: 'text.jlscdlt', value: 'iac3', unit: 'A', translation: true }
      ],
      // 图表
      chart: {
        data: [],
        columns: ['time', 'val1'],
        setting: {
          labelMap: {},
          type: 'line',
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: 'rgba(25,168,154,.5)'
              },
              {
                offset: 1,
                color: 'rgba(25,168,154,0)'
              }
            ])
          },
          area: true
        },
        format: '',
        unit: [],
        extend: {
          textStyle: {
            color: '#fff'
          },
          grid: {
            right: 30,
            left: 30,
            bottom: 10,
            top: 30
          },
          yAxis: {
            name: '',
            position: 'left',
            splitLine: {
              show: true,
              lineStyle: {
                color: '#3845A1'
              }
            },
          },
          legend: {
            show: true,
            textStyle: {
              color: '#fff'
            }
          },
          series: {
            showSymbol: false,
            smooth: true,
          }
        }
      },
    }
  },
  computed: {
  },
  watch: {
    dateType () {
      this.chart.data = []
    }
  },
  created () {
    this.getDeviceList().then(() => {
      this.setParamOptionsByDevice()
      this.handleQuery()
    })
  },
  methods: {

    /** 设置设备参数 */
    setParamOptionsByDevice () {
      const pv = []
      if (this.paramOptions.length > 9) {
        this.paramOptions.splice(10)
      }
      const device = this.inverterList.find(inverter => inverter.id === this.id)
      if (device && device.pvNum) {
        for (let i = 1; i <= device.pvNum; i++) {
          pv.push({ label: `PV${i}${this.$t('text.dianya')}`, value: `vpv${i}`, unit: 'V', translation: false })
          pv.push({ label: `PV${i}${this.$t('text.dl')}`, value: `ipv${i}`, unit: 'A', translation: false })
        }
      }
      this.paramOptions = this.paramOptions.concat(pv)
    },
    /** 查询时间 */
    handleQueryTime (datetype) {
      this.dateType = datetype
      this.handleQuery()
    },
    /** 查询 */
    handleQuery () {
      if (this.disabled) {
        this.$message({
          type: 'warning',
          message: '设备列表为空，无数据查询！'
        })
      } else if (!this.queryParams.time) {
        this.$message({
          type: 'warning',
          message: '请选择时间范围！'
        })
      } else if (this.dateType === 'day' && this.queryParams.fields.length === 0) {
        this.$message({
          type: 'warning',
          message: '请选择参数！'
        })
      } else {
        this.chart.setting.type = 'line'
        const l = getMonthLength(this.queryParams.time)
        const mask = { 'day': 'yyyy-MM', 'month': 'yyyy-MM-dd', 'year': 'yyyy-MM', 'total': 'yyyy' }[this.dateType]
        const mask1 = { 'day': 'yyyy-MM-dd 00:00:00', 'month': 'yyyy-MM-01 00:00:00', 'year': 'yyyy-01-01 00:00:00', 'total': '' }[this.dateType]
        const mask2 = { 'day': 'yyyy-MM-dd 23:59:59', 'month': `yyyy-MM-${l} 23:59:59`, 'year': 'yyyy-12-31 23:59:59', 'total': '' }[this.dateType]
        this.chart.setting.type = this.dateType !== 'day' ? 'histogram' : 'line'
        const fields = this.queryParams.fields.map(o => o.value)
        if (this.dateType === 'day') {
          this.queryDayData(mask1, mask2, fields)
        } else {
          this.queryMonthAndYearAndTotalData(mask, mask1, mask2)
        }
      }
    },
    /** 查询天数据 */
    queryDayData (mask1, mask2, fields) {
      this.fullLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      GetClusterInvHistoryData({
        dateType: this.dateType,
        startTime: this.$parseTime(this.queryParams.time, mask1),
        endTime: this.$parseTime(this.queryParams.time, mask2),
        deviceId: this.id,
        fields: fields
      })
        .then(({ data }) => {
          const chartData = []
          const fieldKeys = Object.keys(data)
          this.chart.columns = ['time'].concat(fieldKeys)
          for (let index = 0; index < data[fieldKeys[0]].length; index++) {
            const item = {}
            fieldKeys.forEach(key => {
              item[key] = data[key][index].val1
              item['time'] = data[key][index].time
            })
            chartData.push(item)
          }
          this.chart.data = combineData(chartData, 'time')
          this.chart.format = 'hh:mm'
          const labelMap = {}
          this.chart.unit = this.queryParams.fields.map(o => {
            labelMap[o.value] = o.translation ? this.$t(o.label) : o.label
            return o.unit
          })
          this.chart.setting.labelMap = labelMap
        }).finally(() => {
          this.fullLoading.close()
        })
    },
    /** 查询月年总数据 */
    queryMonthAndYearAndTotalData (mask, mask1, mask2) {
      this.fullLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      GetClusterMYReportData({
        dateType: this.dateType,
        startTime: this.$parseTime(this.queryParams.time, mask1),
        endTime: this.$parseTime(this.queryParams.time, mask2),
        orgId: this.$store.getters.station.id
      })
        .then(res => {
          this.chart.columns = ['time', 'val1']
          this.chart.unit = ['kWh']
          this.chart.extend.yAxis.name = 'kWh'
          this.chart.format = mask
          this.chart.setting.labelMap = { val1: this.$t('text.dn') }
          this.chart.data = res.data.energys || []
        }).finally(() => {
          this.fullLoading.close()
        })
    },
    /** 获取设备列表 */
    getDeviceList () {
      return new Promise((resolve, reject) => {
        GetInvertersForHistory({
          id: this.$store.getters.station.id
        }).then(({ data }) => {
          const options = data.filter(gateway => gateway.children)
          if (options.length === 0) {
            this.disabled = true
            reject()
          } else {
            this.deviceOptions = options
            options.map(gateway => {
              this.inverterList = this.inverterList.concat(gateway.children)
            })
            this.id = this.inverterList[0].id
            this.queryParams.fields.push(this.paramOptions[3])
            this.queryParams.device = this.inverterList[0]
            resolve()
          }
        })
      })
    },
    /** 设备选择时刷新 */
    changeVal (val) {
      this.setParamOptionsByDevice()
      return val
    }
  }
}
</script>
<style scoped>
.series-history{
   width: 100%;
   height: 100%;
   padding: 0;
   box-sizing: border-box;
   background-color: var(--card-bg-color);
   border-color: var(--card-bg-color);
}

.series-history >>> .el-card__header {
  width: 100%;
  height: 50px;
  padding: 0 15px;
  box-sizing: border-box;
}
.series-history >>> .el-card__header .el-form{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.series-history >>> .el-card__header .el-form .el-form-item{
  margin-bottom: 0;
}

.series-history >>> .el-card__body{
  width: 100%;
  height: calc(100% - 50px);
  padding: 30px 15px 10px;
  box-sizing: border-box;
}
</style>
